// Используем реакт с реактхуками
import React, { useState, useRef, useEffect, useMemo } from "react";
import axiosAPI from "../api/axiosApi";
import * as RB from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-json";
import "./styles-highlighting.css";
import "./InvestigationPage.css";
import { isCorrectMarker, convertMarker } from "./marker_func";
import {
    ExtractionInProgress,
    ExtractionFailed,
    DefaultHexMarker,
} from "./marker_func";
import {
    ScreenExtractionTimeoutMs,
    IdentificationTimeoutMs,
} from "./marker_func";

import default_screen_extract_parameters0 from "./default_screen_extract_parameters0.json";
import default_screen_extract_parameters1 from "./default_screen_extract_parameters1.json";
import default_screen_extract_parameters2 from "./default_screen_extract_parameters2.json";
import default_screen_extract_parameters3 from "./default_screen_extract_parameters3.json";

import default_print_extract_parameters0 from "./default_print_extract_parameters0.json";
import default_print_extract_parameters1 from "./default_print_extract_parameters1.json";
import default_print_extract_parameters2 from "./default_print_extract_parameters2.json";
import default_print_extract_parameters3 from "./default_print_extract_parameters3.json";

const sha256 = require("crypto-js/sha256");
const test_sa = [{ key: 0 }];

import { investigation_columns } from "./investigation_columns";
const columns = investigation_columns;
import { ProgressBar } from "../investigation/ProgressBarComponent";

import {
    faFolderOpen,
    faFileExport,
    faIdCard,
    faBan,
    faTimes,
    faFileUpload,
    faFileDownload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Header from "../common/Header";
import AlertDismissible from "../common/Alert";
import { ImgEditor } from "../common/ImgEditor";
import { Context } from "../common/classes/context";

import { LabelList } from "../investigation/LabelListComponent";
import { authFetch } from "../api/authenticationApi2";
import {
    SCHEDULE_URL,
    STATUS_URL,
    SUBSCRIBE_URL,
    IDENTIFY_URL,
    STATS_URL,
    CANCEL_URL,
    GET_IMAGE_URL,
    CHECK_PRESENCE_URL,
} from "./params.js";
// import "./TestPage.css";
// import "./InvestigationPageA.css";

const ctx = Context.getInstance();
const perpArgs = { arW: 16, arH: 9 };
const defaultStatus = {
    status: 0,
    error: "",
    progress: [0, 1, ""],
};

const getCurrentAccessToken = () => {
    const jwt = localStorage.getItem("access_token");
    let payload = jwt.split(".")[1];
    payload = payload.replace(/-/g, "+").replace(/_/, "/");
    return JSON.parse(window.atob(payload));
};

const AllPrintAlgos = [
    {
        key: "xwn",
        showName: "Горизонтальный сдвиг",
        value: default_print_extract_parameters0,
        name: "xwn",
    },
    {
        key: "strike",
        showName: "Перечёркивание",
        value: default_print_extract_parameters1,
        name: "strike",
    },
    {
        key: "l_scale",
        showName: "Горизонтальное сжатие",
        value: default_print_extract_parameters2,
        name: "l_scale",
    },
    {
        key: "ls_ma",
        showName: "Горизонтальное сжатие (альтернативный)",
        value: default_print_extract_parameters3,
        name: "l_scale",
    },
];

const AllScreenAlgos = [
    {
        key: "neurostatic-one",
        showName: "Размытие",
        value: default_screen_extract_parameters0,
        name: "ns",
    },
    {
        key: "neurostatic",
        showName: "Размытие (автоподбор)",
        value: default_screen_extract_parameters2,
        name: "ns",
    },
    {
        key: "neurostatic-autocorrection",
        showName: "Размытие (автокоррекция)",
        value: default_screen_extract_parameters3,
        name: "ns",
    },
    // {
    //     key: "qrcode",
    //     showName: "QR-код",
    //     value: default_screen_extract_parameters1,
    //     name: "qr",
    // },
];
const defaultScreenAlgIndex = 0;
const defaultPrintAlgIndex = 0;
export const InvestigationPage = ({ alg_type }) => {
    const filename = useRef(null);
    const thisPerpArgs = (() => {
        switch (alg_type) {
            case "print":
                return { arW: 21, arH: 30 };
            case "screen":
                return { arW: 16, arH: 9 };
            default:
                return { arW: 1, arH: 1 };
        }
    })(alg_type);
    const [AllAlgos, defaultAlgIndex] = (() => {
        switch (alg_type) {
            case "print":
                return [AllPrintAlgos, defaultPrintAlgIndex];
            case "screen":
                return [AllScreenAlgos, defaultScreenAlgIndex];
            default:
                throw Error("No such algorithm: " + alg_type);
        }
    })();
    const [image, setImage] = useState();
    const [show, setShow] = useState(false);
    const [binMode, setBinMode] = useState(false);
    const [marker, setMarker] = useState(
        convertMarker(DefaultHexMarker, binMode)
    );
    const [algIndex, setAlgIndex] = useState(defaultAlgIndex);
    // const [algoName, setAlgoName] = useState(AllAlgos[defaultAlgIndex].name);
    const [algoKey, setAlgoKey] = useState(AllAlgos[defaultAlgIndex].key);
    const [extractionConfig, setExtractionConfig] = useState(
        JSON.stringify(AllAlgos[defaultAlgIndex].value, 0, 4)
    );

    const [selectedMarks, setSelectedMarks] = useState(test_sa);
    const [lastTaskStatus, setLastTaskStatus] = useState(null);
    const [labelList, setLabelList] = useState([]);
    const [isSubscribed, setSubscribed] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [showError, setShowError] = useState(false);
    const wsCon = useRef(null);
    const fileInput = useRef(null);
    const cnfFileInput = useRef(null);
    useEffect(() => {
        requestImage();
    }, []);
    useEffect(() => {
        if (!isSubscribed) {
            // setInterval(sendStatus, 500);
            sendStatus();
            setSubscribed(true);
        }
    }, []);
    /**
     * @param {Object} status
     * @returns {Object}
     */
    const processStatus = (status) => {
        if (Object.keys(status).length === 0) {
            return null;
        }
        const latestIdx = Math.max.apply(
            null,
            Object.keys(status).map((x) => Number(x))
        );
        const latestTask = status[latestIdx];
        return latestTask;
    };
    const sendStatus = async () => {
        const jwt = getCurrentAccessToken();
        const username = jwt["username"];
        const objToSend = {
            user_id: username,
            alg_type: alg_type,
        };
        try {
            const response = await authFetch(STATUS_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(objToSend),
            });
            if (response.status === 503) {
                const taskStatus = {
                    status: 3, // means error occured
                    error: "Сервис извлечения недоступен",
                    progress: "",
                };
                setLastTaskStatus(taskStatus);
                return;
            }
            const data = await response.json();
            if (response.status !== 200) {
                const taskStatus = {
                    status: 3, // means error occured
                    error: data.detail,
                    progress: "",
                };
                setLastTaskStatus(taskStatus);

                return;
            }
            // const taskStatus = processStatus(data);
            const taskStatus = data;
            if (taskStatus == null) {
                return;
            }
            setLastTaskStatus(taskStatus);

            if (taskStatus["status"] === 2) {
                let lbList = await checkMarksPresence(
                    taskStatus["result"]["labels"]
                );
                lbList = lbList.sort((a, b) => b.score - a.score);
                setLabelList(lbList);
                setMarker(
                    convertMarker(lbList[0].label.toUpperCase(), binMode)
                );
            } else if (taskStatus["status"] === 3) {
                const tastStatus = {
                    status: 3,
                    error: taskStatus["error"],
                    progress: "",
                };
            } else if (
                taskStatus["status"] === 1 ||
                taskStatus["status"] === 0
            ) {
                await subscribeForProgress();
            }
        } catch (error) {
            const taskStatus = {
                status: 3,
                progress: "",
                error: error.stack.toString(),
            };
            setLastTaskStatus(taskStatus);

            throw error;
        }
        // console.log(Object.keys(data));
    };
    const subscribeForProgress = async () => {
        const jwt = getCurrentAccessToken();
        const username = jwt["username"];
        /**@type {WebSocket} */
        let ws;
        if (wsCon.current !== null) wsCon.current.close(1000);
        wsCon.current = new WebSocket(SUBSCRIBE_URL);
        wsCon.current.msgCount = 0;
        wsCon.current.onmessage = async (event) => {
            wsCon.current.msgCount += 1;
            let taskStatus = {};
            const data = JSON.parse(event.data);
            if (data["type"] === 211) {
                taskStatus = {
                    status: 1,
                    error: "",
                    progress: data["data"]["progress"],
                };
            } else if (data["type"] === 212) {
                taskStatus = {
                    status: 2,
                    error: "",
                    result: data["data"],
                    progress: [1, 1, "qwe"],
                };
                let resLabelList = data["data"]["labels"];
                resLabelList = await checkMarksPresence(resLabelList);
                resLabelList.sort((a, b) => b.score - a.score);
                setLabelList(resLabelList);
                wsCon.current.close(1000);
                console.log(data["data"]?.log);
            } else if (data["type"] === 213) {
                taskStatus = {
                    status: 3,
                    error: data["data"]["error"],
                    progress: "",
                };
                wsCon.current.close(1000);
                // let err_obj = JSON.parse(data.data.error);
                // console.log(err_obj?.log);
            } else if (data["type"] === 214) {
                taskStatus = {
                    status: 4,
                    error: "",
                    progress: "",
                };
                wsCon.current.close(1000);
            }
            taskStatus.msgCount = wsCon.current.msgCount;
            setLastTaskStatus(taskStatus);
        };
        wsCon.current.onopen = () => {
            wsCon.current.send(
                JSON.stringify({
                    user_id: username,
                    alg_type: alg_type,
                })
            );
        };
    };
    const scheduleTask = async () => {
        const imgData = ctx.offScrCnv.toDataURL("image/png", 1);
        const jwt = getCurrentAccessToken();
        const username = jwt["username"];
        let config = "";
        try {
            config = JSON.parse(extractionConfig);
        } catch (e) {
            setErrorMsg(
                "Синтаксическая ошибка в конфигурации. Если не получается ее исправить, обновите страницу."
            );
            setShowError(true);
            return;
        }
        setLabelList([]);
        // setLastTaskStatus(null);
        const taskStatus = {
            status: 10, // means task is sending
            error: "",
            progress: "",
        };
        setLastTaskStatus(taskStatus);
        if (imgData) {
            const objToSend = {
                img: imgData,
                filename: filename.current,
                alg_name: AllAlgos[algIndex].name,
                config: config,
                user_id: username,
            };
            try {
                const response = await authFetch(SCHEDULE_URL, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(objToSend),
                });

                if (!response.ok) {
                    if (response.status === 513)
                        setErrorMsg(
                            "Достигнуто максимальное число выполняющихся задач для данного пользователя"
                        );
                    else if (response.status === 512)
                        setErrorMsg("Недостаточно ресурсов на сервере");
                    else if (response.status === 507)
                        setErrorMsg(
                            "Недостаточно места на диске. Обратитесь к администратору."
                        );
                    else if (response.status == 515) {
                        const data = await response.json();
                        setErrorMsg(data.detail.message);
                        setShowError(true);
                        const taskStatus = {
                            status: 3, // means error occured
                            error: `Ошибка лицензии: "${data.detail.message}". Извлечение недоступно при недействительной лицензии.`,
                            progress: "",
                        };
                        setLastTaskStatus(taskStatus);
                        return;
                    } else {
                        const data = await response.json();
                        setErrorMsg(data["detail"]);
                    }

                    setShowError(true);
                } 
            } catch (error) {
                console.log(error);
            }
            sendStatus();
        }
    };
    const onFileChange = (event) => {
        // Update the state
        const reader = new FileReader();
        reader.onload = () => {
            // ctx.origImg.src = reader.result;

            ctx.replaceImg(reader.result);
            setImage(reader.result);
            setLastTaskStatus(null);
            setLabelList([]);
            setMarker(convertMarker(DefaultHexMarker, binMode));
        };
        reader.readAsDataURL(event.target.files[0]);
        filename.current = event.target.files[0].name;
        ctx.filename = filename.current;
        event.target.value = null;
    };
    const onCnfFileChange = (event) => {
        const reader = new FileReader();
        reader.onload = () => {
            setExtractionConfig(reader.result);
        };
        reader.readAsText(event.target.files[0]);
    };
    const onCnfDwnClick = (event) => {
        const link = document.createElement("a");

        const file = new Blob([extractionConfig], { type: "text/plain" });
        link.href = URL.createObjectURL(file);
        const nowDate = new Date();
        link.download = `${nowDate.toISOString()}_${alg_type}_${
            AllAlgos[algIndex].key
        }_dmi.json`;
        link.click();
        URL.revokeObjectURL(link.href);
    };
    const requestImage = async (e) => {
        const objToSend = { alg_type: alg_type };
        try {
            const response = await authFetch(GET_IMAGE_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(objToSend),
            });
            if (response.status === 503) {
                return;
            }
            if (!response.ok) {
                const data = await response.json();
                if (data["detail"].match(/image not found/i) != null) {
                    // setErrorMsg("Не найдено изображение для последней задачи");
                    return;
                } else if (
                    data["detail"].match(/no tasks for this user/i) != null
                ) {
                    return;
                } else {
                    setErrorMsg(data["detail"]);
                }
                setShowError(true);
                return;
            }
            filename.current = response.headers.get("Filename");
            ctx.filename = filename.current;
            const data = await response.blob();
            // const data = await response.json();

            const imgUrl = URL.createObjectURL(data);
            ctx.replaceImg(imgUrl);
            setImage(imgUrl);

            // ctx.origImg.src = imgUrl;
        } catch (error) {
            console.log(error);
        }
    };
    const onLabelListSelect = (idx) => {
        let mrk = labelList[idx].label.toUpperCase();
        if (binMode) mrk = convertMarker(mrk, true);
        setMarker(mrk);
    };
    const setIdentified = (marker, value) => {
        let newLabelList = labelList.map((item) => {
            if (item.label.toUpperCase() === marker.toUpperCase())
                return {
                    label: item.label,
                    score: item.score,
                    identified: value,
                };
            return item;
        });
        setLabelList(newLabelList);
    };
    const getIdentification = async (itype) => {
        // backend ждет от нас строку с бинарной меткой
        const objToSend = { marker: convertMarker(marker, true) };
        try {
            const response = await authFetch(IDENTIFY_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(objToSend),
            });
            const data = await response.json();
            setSelectedMarks(data);
            const hexLabel = convertMarker(marker, false);
            setIdentified(hexLabel, data.length > 0);
            console.log(data);
        } catch (error) {
            console.log(error);
        }

        setShow(true);
    };
    const checkMarksPresence = async (lList) => {
        if (lList.length == 0) return;
        let ll = lList.map((val) => convertMarker(val["label"], true));
        const objToSend = { marks: ll };
        try {
            const response = await authFetch(CHECK_PRESENCE_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(objToSend),
            });
            const data = await response.json();
            let newLabelList = lList.map((val) => {
                const binMarker = convertMarker(val["label"], true);
                return { ...val, identified: data.includes(binMarker) };
            });
            return newLabelList;
        } catch (error) {
            console.log(error);
        }
    };
    const onCancelClick = async () => {
        const objToSend = { alg_type: alg_type };
        try {
            const response = await authFetch(CANCEL_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(objToSend),
            });
            const data = await response.json();
        } catch (error) {
            console.log(error);
        }
    };
    const llRowClass = (() => {
        switch (labelList.length) {
            case 1:
                return "ll-row-item-1";
            default:
                return "ll-row-item-2";
        }
    })();
    useEffect(() => {
        // This useEffect responsible for download/upload buttons placing
        // and prevents them from scrolling beyond user vision
        const cnfEditorDiv = document.querySelector("#config-editor-div");
        const cnfEditorInnerDiv = document.querySelector(
            "#config-editor-inner-div"
        );
        const cnfEditorOuterDiv = document.querySelector(
            "#config-editor-outer-div"
        );
        const editorDiv = document.querySelector("#config-editor");
        const dwnlBtn = document.querySelector("#cnf-download-btn");
        const uplBtn = document.querySelector("#cnf-upload-btn");

        const childHeight = editorDiv.scrollHeight;
        const parentHeight = cnfEditorDiv.clientHeight;

        if (childHeight <= parentHeight) {
            cnfEditorInnerDiv.appendChild(dwnlBtn);
            cnfEditorInnerDiv.appendChild(uplBtn);
            uplBtn.style.right = "0.9em";
            dwnlBtn.style.right = "0";
        } else {
            cnfEditorOuterDiv.appendChild(dwnlBtn);
            cnfEditorOuterDiv.appendChild(uplBtn);

            uplBtn.style.right = "1.5em";
            dwnlBtn.style.right = "0.6em";
        }
    }, [extractionConfig, lastTaskStatus, labelList]);
    return (
        // <RB.Container fluid id={styles["root-container"]}>
        <>
            <Header />
            <RB.Container fluid id="root-container">
                <RB.Row className="h-100" id="main-row">
                    <RB.Col
                        id="left-col"
                        className="d-flex flex-column p-0 h-100"
                        lg={4}
                    >
                        <RB.Row
                            id="open-image-button-row"
                            className="py-3 justify-content-center"
                        >
                            <RB.Button
                                variant="secondary"
                                className="w-75"
                                onClick={() => fileInput.current.click()}
                            >
                                <FontAwesomeIcon
                                    icon={faFolderOpen}
                                    fixedWidth
                                />
                                Открыть изображение
                            </RB.Button>
                        </RB.Row>
                        <RB.Row
                            id="dropdown-row"
                            className="py-3 justify-content-center"
                        >
                            <RB.Dropdown
                                className="w-75"
                                onSelect={(eventKey) => {
                                    setAlgIndex(eventKey);
                                    setExtractionConfig(
                                        JSON.stringify(
                                            AllAlgos[eventKey].value,
                                            0,
                                            4
                                        )
                                    );
                                }}
                            >
                                <RB.Dropdown.Toggle
                                    className="w-100"
                                    variant="outline-info"
                                >
                                    {AllAlgos[algIndex].showName}
                                </RB.Dropdown.Toggle>
                                <RB.Dropdown.Menu className="w-100 text-center">
                                    {AllAlgos.map((item, index) => {
                                        return (
                                            <RB.Dropdown.Item
                                                key={index}
                                                eventKey={index}
                                            >
                                                {item.showName}
                                            </RB.Dropdown.Item>
                                        );
                                    })}
                                </RB.Dropdown.Menu>
                            </RB.Dropdown>
                        </RB.Row>
                        <RB.Row
                            id="config-editor-row"
                            className="py-3 justify-content-center"
                        >
                            <div id="config-editor-outer-div">
                                <div id="config-editor-div">
                                    <div
                                        id="config-editor-inner-div"
                                        style={{
                                            position: "relative",
                                            overflowY: "auto",

                                            // height: "auto",
                                        }}
                                    >
                                        <Editor
                                            // className="w-75"
                                            id="config-editor"
                                            value={extractionConfig}
                                            onValueChange={(config) =>
                                                setExtractionConfig(config)
                                            }
                                            highlight={(cod) =>
                                                highlight(cod, languages.json)
                                            }
                                            padding={10}
                                            style={{
                                                fontFamily:
                                                    '"Fira code", "Fira Mono", monospace',
                                                fontSize: 12,
                                                width: "100%",
                                            }}
                                        />
                                        {/* <div
                                            id="cnf-download-btn"
                                            type="button"
                                            style={{
                                                position: "absolute",
                                                right: "1em",
                                                // left: -1,
                                                bottom: 0,
                                            }}
                                        > */}
                                        <FontAwesomeIcon
                                            icon={faFileUpload}
                                            onClick={() =>
                                                cnfFileInput.current.click()
                                            }
                                            id="cnf-upload-btn"
                                            title="Импорт конфигурации"
                                            className="cnf-ie-btn"
                                            size="lg"
                                            fixedWidth
                                            style={{
                                                position: "absolute",
                                                // left: 0,
                                                bottom: "0.2em",
                                            }}
                                        />
                                        <FontAwesomeIcon
                                            icon={faFileDownload}
                                            onClick={onCnfDwnClick}
                                            id="cnf-download-btn"
                                            title="Экспорт конфигурации"
                                            className="cnf-ie-btn"
                                            size="lg"
                                            fixedWidth
                                            style={{
                                                position: "absolute",
                                                bottom: "0.2em",
                                            }}
                                        />
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </RB.Row>
                        <RB.Row
                            id="extract-button-row"
                            className="py-3 justify-content-center"
                        >
                            <RB.Button
                                onClick={() => scheduleTask()}
                                variant="primary"
                                className="w-75"
                                disabled={!image}
                                title={!image ? "Загрузите изображение для извлечения" : ""}
                            >
                                <FontAwesomeIcon
                                    icon={faFileExport}
                                    fixedWidth
                                />
                                Извлечь метку
                            </RB.Button>
                        </RB.Row>
                        {lastTaskStatus !== null && (
                            <RB.Row
                                id="test-progress-status-row"
                                className="py-3 justify-content-center"
                            >
                                <div className="w-75 d-flex">
                                    <ProgressBar
                                        status={lastTaskStatus}
                                    ></ProgressBar>
                                    <RB.Button
                                        id="cancel-button"
                                        variant="link"
                                        onClick={() => onCancelClick()}
                                    >
                                        <FontAwesomeIcon
                                            id="cancel-button-icon"
                                            icon={faTimes}
                                            color="#6c757d"
                                            title="Нажмите, чтобы отменить выполнение задачи"
                                        />
                                    </RB.Button>
                                </div>
                            </RB.Row>
                        )}

                        {labelList.length !== 0 && (
                            <RB.Row
                                id="test-label-list-row"
                                className={
                                    "py-0 justify-content-center " + llRowClass
                                }
                            >
                                <LabelList
                                    labelList={labelList}
                                    id="test-label-list"
                                    onSelect={onLabelListSelect}
                                ></LabelList>
                            </RB.Row>
                        )}
                        <RB.Row
                            id="input-label-row"
                            className="py-3 justify-content-center"
                        >
                            <RB.InputGroup className="w-75" hasValidation>
                                <RB.FormControl
                                    placeholder="Hex-8 или Bin-32 строка"
                                    aria-label="marker"
                                    value={marker}
                                    isInvalid={
                                        !isCorrectMarker(marker, binMode)
                                    }
                                    required
                                    onChange={(e) => setMarker(e.target.value)}
                                />
                                <RB.InputGroup.Append
                                    style={{
                                        alignItems: "center",
                                        marginLeft: "2px",
                                    }}
                                >
                                    <RB.Form.Check
                                        type="switch"
                                        id="custom-switch"
                                        label="Бинарный вид"
                                        onClick={(e) => {
                                            const newMode = e.target.checked;
                                            setBinMode(newMode);
                                            setMarker(
                                                convertMarker(marker, newMode)
                                            );
                                        }}
                                    />
                                </RB.InputGroup.Append>
                            </RB.InputGroup>
                        </RB.Row>
                        <RB.Row
                            id="identify-button-row"
                            className="py-3 justify-content-center"
                        >
                            <RB.Button
                                className="w-75"
                                onClick={() => getIdentification()}
                            >
                                <FontAwesomeIcon icon={faIdCard} fixedWidth />
                                Идентифицировать метку
                            </RB.Button>
                        </RB.Row>
                    </RB.Col>
                    <RB.Col id="right-col" className="p-0 h-100" lg={8}>
                        <input
                            type="file"
                            onInput={onFileChange}
                            name="upload-file"
                            ref={fileInput}
                            style={{ display: "none" }}
                        />
                        <input
                            type="file"
                            onInput={onCnfFileChange}
                            name="upload-сnf-file"
                            ref={cnfFileInput}
                            style={{ display: "none" }}
                        />
                        <ImgEditor
                            // id={styles["img-editor"]}
                            context={ctx}
                            image={image}
                            perpArgs={thisPerpArgs}
                        />
                    </RB.Col>
                </RB.Row>
                <RB.Modal
                    show={show}
                    onHide={() => setShow(false)}
                    size={"xl"}
                    aria-labelledby="example-custom-modal-styling-title"
                >
                    <RB.Modal.Header closeButton>
                        <RB.Modal.Title id="example-custom-modal-styling-title">
                            {marker}
                        </RB.Modal.Title>
                    </RB.Modal.Header>
                    <RB.Modal.Body>
                        <BootstrapTable
                            id="mark-table"
                            keyField="key"
                            data={selectedMarks}
                            columns={columns}
                            rowStyle={{ fontSize: "60%" }}
                            pagination={paginationFactory()}
                            bootstrap4
                            striped
                            hover
                            condensed
                        />
                    </RB.Modal.Body>
                </RB.Modal>
                <RB.Modal
                    show={showError}
                    onHide={() => {
                        setShowError(false);
                    }}
                    size={"lg"}
                >
                    <RB.Modal.Header closeButton>
                        <RB.Modal.Title>Информация об ошибке</RB.Modal.Title>
                    </RB.Modal.Header>
                    <RB.Modal.Body>
                        <RB.Alert variant="danger">{errorMsg}</RB.Alert>
                    </RB.Modal.Body>
                </RB.Modal>
            </RB.Container>
        </>
    );
};
